import { DEBOUNCED_AUTOSAVE_EXP_TEMPLATE_DELAY } from '@experiment-details/constants/template';
import useSaveExpDetailsTemplateMutation from '@experiment-details/hooks/template/useSaveExpDetailsTemplateMutation';
import useExpDetailsSelectedTemplate from '@experiment-details/hooks/useExpDetailsSelectedTemplate';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';
import { useEffect, useRef } from 'react';

const useExpDetailsAutosaveLocalView = () => {
  const isRequestSent = useRef<boolean>(false);
  const { templateData: currentTemplate } = useExpDetailsSelectedTemplate();
  const saveTemplateMutation = useSaveExpDetailsTemplateMutation();

  useEffect(() => {
    if (isRequestSent.current || !currentTemplate) return;

    const timeNow = new Date().getTime();
    const templateLastUpdate = currentTemplate.lastUpdatedAt || 0;

    const isShouldBeSaved =
      timeNow - templateLastUpdate > DEBOUNCED_AUTOSAVE_EXP_TEMPLATE_DELAY;

    if (
      isShouldBeSaved &&
      currentTemplate.isLocalTemplate &&
      currentTemplate.templateId !== AUTO_GENERATED_OPTION_ID
    ) {
      saveTemplateMutation.mutate(
        { templateData: currentTemplate },
        {
          onSuccess: () => {
            isRequestSent.current = true;
          }
        }
      );
    }
  }, [currentTemplate, isRequestSent]);
};

export default useExpDetailsAutosaveLocalView;
